import React from "react";
import cx from "classnames";

const TotCount = (props) => {
  const { color = "green", className = "", value = 0, sm = false } = props;
  return (
    <div className={cx("tot-count", `bg-gr-${color}`, { sm, className })}>
      <p>{value}</p>
    </div>
  );
};

export default TotCount;
